import { Container } from 'inversify';
import { BillingService } from 'src/app/accounting/shared/billing.service';
import CheckoutDataService from 'src/app/accounting/payment-gateway/checkout-service';

export function setup(container: Container) {
	container.bind(BillingService).toSelf();
	container.bind(CheckoutDataService).toSelf();
}



// WEBPACK FOOTER //
// ./src/app/accounting/accounting.config.ts